import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { selectIsPayPerInviteEnabled } from '@mkp/debug/state';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';

export const isPayPerInviteEnabledGuard: CanMatchFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectIsPayPerInviteEnabled).pipe(
    take(1),
    map(
      (isPayPerInviteEnabled) => isPayPerInviteEnabled || router.parseUrl(AppConfig.routes.error404)
    )
  );
};
